'use strict';

module.exports = '2.15.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 341
// module chunks = 0